<template>
    <div class="selected-district-data-item">
        <!-- <h4>STATE LEG</h4>
        The 2020 United States redistricting cycle will take place following the completion of the 2020 United States Census. In all fifty states, various bodies will re-draw state legislative districts. States that are apportioned more than one seat in the United States House of Representatives will also draw new districts for that legislative body. The rules for redistricting vary from state to state, but all states draw new legislative and congressional maps either in the state legislature, in redistricting commissions, or through some combination of the state legislature and a redistricting commission. Though various laws and court decisions have put constraints on redistricting, many redistricting institutions continue to practice gerrymandering, which involves drawing new districts with the intention of giving a political advantage to specific groups.[1] Political parties prepare for redistricting years in advance, and partisan control of redistricting institutions can provide a party with major advantages.[2] Aside from the possibility of mid-decade redistricting,[3] the districts drawn in the 2020 redistricting cycle will remain in effect until the next round of redistricting following the 2030 United States Census. -->
<!--         
        <p>State officials across America have begun the process of redrawing congressional &amp; state legislative district based on the 2020 Census. The new maps will impact everyone for the next 10 years.</p>
        
        <p>Many factors will go into drawing new maps. A fundamental issue is how each district's population has changed since the last redistricting cycle. The <em>1 person, 1 vote</em> principle says that legislative districts should have an equal number of people. But populations have shifted and grown or declined in the last 10 years. Some districts now have many more people than the average district size; <span style="color:#BB691F;font-weight:bold;">they will need to <em>shrink</em></span>. Other districts now have far fewer people than average; <span style="color:#3288bd;font-weight:bold;">they will need to <em>expand</em></span>.
        </p>
        
        <p>The maps on this page use the latest census estimates (American Community Survey data through 2019) to provide a <em>first look</em> at these population shifts. <strong>Will your district need to grow or contract? Click/search the map to find out!</strong></p> -->

        <v-alert
                  border="left"
                  dense
                  colored-border
                  color="info"
                  elevation="2"
                  class="text-body-1"
                >
                <p class="mt-1 mb-2">This website was launched when the 2020 Census was complete but before redistricting began in most states. It reflects congressional &amp; state legislative districts in effect before the 2021-2022 redistricting cycle. <strong>You can view new, post-redistricting maps at our <a href="https://us.redistrictingandyou.org/" target="_blank">US version of Redistricting &amp; You</a> to compare new districts with pre-2020 Census lines.</strong>
                  </p>

                <p class="mt-1 mb-2">You can also use the links below to compare and analyze old &amp; new district plans in specific states:
        </p>
                <ul class="mb-3">

          <li>
            <strong><a href="https://newyork.redistrictingandyou.org" target="_blank">New York State</a></strong>
          </li>
          <li>
            <strong><a href="https://massachusetts.redistrictingandyou.org" target="_blank">Massachusetts</a></strong>
          </li>
          <li>
            <strong><a href="https://northcarolina.redistrictingandyou.org" target="_blank">North Carolina</a></strong>
          </li>
          <li>
            <strong><a href="https://georgia.redistrictingandyou.org" target="_blank">Georgia</a></strong>
          </li>
          <li>
            <strong><a href="https://pennsylvania.redistrictingandyou.org" target="_blank">Pennsylvania</a></strong>
          </li>
          <li>
            <strong><a href="https://florida.redistrictingandyou.org" target="_blank">Florida</a></strong>
          </li>
          <li>
            <strong><a href="https://louisiana.redistrictingandyou.org/" target="_blank">Louisiana</a></strong>
          </li>
          <li>
            <strong><a href="https://newjersey.redistrictingandyou.org/" target="_blank">New Jersey</a></strong>
          </li>
          <li>
            <strong><a href="https://missouri.redistrictingandyou.org/" target="_blank">Missouri</a></strong>
          </li>
          <li>
            <strong><a href="https://mississippi.redistrictingandyou.org/" target="_blank">Mississippi</a></strong>
          </li>
        </ul>
                </v-alert>

                <hr />
<!--                 
        <p class="mt-1 mb-2">Use the links below to compare and analyze old &amp; new district plans across the United States and in specific states:
        </p>
        <ul class="mb-3">
          <li>
            <strong><a href="https://us.redistrictingandyou.org" target="_blank">United States</a></strong>
          </li>
          <li>
            <strong><a href="https://newyork.redistrictingandyou.org" target="_blank">New York State</a></strong>
          </li>
          <li>
            <strong><a href="https://massachusetts.redistrictingandyou.org" target="_blank">Massachusetts</a></strong>
          </li>
          <li>
            <strong><a href="https://northcarolina.redistrictingandyou.org" target="_blank">North Carolina</a></strong>
          </li>
          <li>
            <strong><a href="https://georgia.redistrictingandyou.org" target="_blank">Georgia</a></strong>
          </li>
          <li>
            <strong><a href="https://pennsylvania.redistrictingandyou.org" target="_blank">Pennsylvania</a></strong>
          </li>
          <li>
            <strong><a href="https://florida.redistrictingandyou.org" target="_blank">Florida</a></strong>
          </li>
          <li>
            <strong><a href="https://louisiana.redistrictingandyou.org/" target="_blank">Louisiana</a></strong>
          </li>
          <li>
            <strong><a href="https://newjersey.redistrictingandyou.org/" target="_blank">New Jersey</a></strong>
          </li>
          <li>
            <strong><a href="https://missouri.redistrictingandyou.org/" target="_blank">Missouri</a></strong>
          </li>
          <li>
            <strong><a href="https://mississippi.redistrictingandyou.org/" target="_blank">Mississippi</a></strong>
          </li>
        </ul> -->

  
        <p class="text-body-1 mt-1">
          <strong>DESCRIPTION CIRCA 2021:</strong>
        </p>
       <p>State officials across America are <!-- preparing to  -->redrawing congressional &amp; state legislative districts based on the 2020 Census. The new maps will impact everyone for the next 10 years.</p>
        
        <p>The maps on this page show population patterns for current districts based on 2020 Census data <!-- estimates through 2019  -->and, for congressional districts, the number of seats apportioned to each state based on the 2020 Census. <strong>These maps reveal population shifts that will set the stage for post-2020 redistricting.</strong></p>
        
        <p style="font-size:1.1em;"><strong>Will your district need to <span class="text-needtoexpand-color">expand</span> or <span class="text-needtoshrink-color">shrink</span>? Click the map to find out!</strong></p>
        

        
        <p class="mt-4">Many factors will go into drawing new maps. A fundamental issue is how each district's population has changed since redistricting after the 2010 Census. The <em>1 person, 1 vote</em> principle says that legislative districts should have an equal number of people. But populations have changed over the last 10 years. Some districts now have many more people than the average district size: <span class="text-needtoshrink-color font-weight-bold">they will need to <em>shrink</em></span>. Other districts now have far fewer people than average: <span class="text-needtoexpand-color font-weight-bold">they will need to <em>expand</em></span>. Click the map for more info.
        </p>
    </div>
</template>
<script>
export default {
    name: 'SideMenuStateLegEmpty',
    data: function(){
    return{}
  },
}
</script>
<style scoped>

</style>